<template>
  <div class="container">
    <van-tabs v-model="active" sticky swipeable @change="onChange">
      <van-tab
        v-for="data in tabData"
        :name="data.id"
        :key="data.id"
        :title="data.name"
        line-height="100"
      >
        <van-panel style="height:86vh">
          <div slot="header">
            <van-dropdown-menu>
              <van-dropdown-item v-model="dropDown.drop1.value" :options="dropDown.drop1.options" />
              <van-dropdown-item v-model="dropDown.drop2.value" :options="dropDown.drop2.options" />
            </van-dropdown-menu>
          </div>
          <div slot="default">
            <van-list v-model="loading" :finished="finished" finished-text="到底啦~" @load="onLoad">
              <!-- <van-skeleton title avatar :row="3" :loading="loading"> -->

              <van-card
                v-for="item in goodsList"
                :key="item.goodsId"
                :price="item.goodsPrice"
                :title="item.goodsName"
                :thumb="item.imageUrl"
                class="card_shop"
              >
                <div slot="num">
                  <van-icon
                    name="cart-o"
                    size="5vw"
                    color="#ee0a24"
                    @click="onIconClick(item.goodsId)"
                  />
                </div>
              </van-card>
              <!-- </van-skeleton> -->
            </van-list>
          </div>
        </van-panel>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import {
  Tab,
  Tabs,
  Skeleton,
  Panel,
  DropdownMenu,
  DropdownItem,
  Card,
  List,
  Button,
  Icon
} from "vant";
import service from "../../api/group/index";
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Skeleton.name]: Skeleton,
    [Panel.name]: Panel,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Card.name]: Card,
    [List.name]: List,
    [Button.name]: Button,
    [Icon.name]: Icon
  },
  data() {
    return {
      tabData: [],
      active: 0,
      loading: false,
      dropDown: {
        drop1: {
          value: 0,
          options: [
            { text: "综合排序", value: 0 },
            { text: "销量排序", value: 1 },
            { text: "价格排序", value: 2 }
          ]
        },
        drop2: {
          value: 0,
          options: [
            { text: "列表展示", value: 0 },
            { text: "格子展示", value: 1 }
          ]
        }
      },
      goodsList: [],
      finished: true
    };
  },
  methods: {
    init() {
      service
        .getNestChildren(this.$route.query.id)
        .then(response => {
          this.tabData = response.data;
          this.active = this.$route.query.id;
          service
            .getChildItems(this.$route.query.id, 0, 10)
            .then(response => {
              this.goodsList = response.data;
              this.loading = false;
            })
            .catch();
        })
        .catch();
    },
    onLoad() {},
    onChange(name) {
      service
        .getChildItems(name, 0, 10)
        .then(response => {
          this.goodsList = response.data;
          this.loading = false;
        })
        .catch();
    },
    onIconClick(goodsId) {
      this.$router.push({ name: "goods", query: { id: goodsId } });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.container {
  // position: fixed;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}
</style>